import { Component, Input, SimpleChange } from '@angular/core';

import { ComponentBase } from '../../../../../base-classes/componet-base';
import { WardsService } from '../../../../../services/wards-service/wards.service';
import { Exam } from '../../models/exam';
import { ExamsService } from '../../services/exams.service';
import { switchMap } from 'rxjs/operators';
import { FileDownloadService } from 'src/app/services/file-download-service/file-download.service';

@Component({
  selector: 'app-exam-details',
  templateUrl: './exam-details.component.html',
  styleUrls: ['./exam-details.component.scss']
})
export class ExamDetailsComponent extends ComponentBase {

  constructor(private wardsService: WardsService
    , private examsService: ExamsService
    , private fileDownloadService: FileDownloadService) {
    super();
  }
  public selectedStudentName: string;
  isResultPublished: boolean;
  @Input() exam: Exam

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('grey-background');
    let sub = this.wardsService.ward$
      .subscribe(res => {
        this.selectedStudentName = res.first_name;
      });
    this.addSubscription(sub);
  }

  ngOnChanges(changes: SimpleChange) {
    this.isResultPublished = false;
    if(changes['exam'].currentValue) {
      let publishedItem = changes['exam'].currentValue.tests.find(t => t.examination_subject_result_status == 2);
      if (publishedItem) {
        this.isResultPublished = true;
      }
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('grey-background');
  }

  getPublishedTests() {
    if (this.exam && this.exam.tests) {
      return this.exam.tests.filter(e => e.examination_subject_result_status == 2)
        .sort();
    }
  }

  getScheduledTests() {
    if (this.exam && this.exam.tests) {
      return this.exam.tests.filter(e => e.examination_subject_result_status != 2);
    }
  }

  onDownloadReportCard() {
    let sub = this.examsService.getExamReportCardUrl(this.exam.examination_id)
    .pipe(
      switchMap(res => {
        return this.fileDownloadService.downloadAndOpen(res['url'], this.exam.exam_name+'.pdf', "application/pdf", true);
      })
    ).subscribe();
    this.addSubscription(sub);
  }
}
